// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import '../../helpers/base.less';
import './Text.less';

/**
 * `Text` component is a basic building block for UI. It is used when you need to display inline text on the screen.
 */
const Text = ({ baseClassName, className, children, component: Tag, intent, bold, italic, ...props }) => {
    if (bold) {
        children = <b>{children}</b>;
    }

    if (italic) {
        children = <i>{children}</i>;
    }

    return (
        <Tag
            className={classNames(
                baseClassName,
                {
                    [`${baseClassName}--${intent}`]: intent,
                },
                className
            )}
            {...props}
        >
            {children}
        </Tag>
    );
};

Text.propTypes = {
    /**
     * Content of the `Text`.
     */
    children: PropTypes.node,
    /**
     * Component to render as the root element.
     */
    component: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]),
    /**
     * Visual intent color to apply to component.
     */
    intent: PropTypes.oneOf(['info', 'success', 'warning', 'danger', 'muted']),
    /**
     * Indicates that contents have strong importance.
     */
    bold: PropTypes.bool,
    /**
     * Indicates that contents are set off from the normal text for some reason.
     */
    italic: PropTypes.bool,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Text.defaultProps = {
    children: null,
    component: 'span',
    intent: null,
    bold: false,
    italic: false,
    className: null,
    baseClassName: `${CLS_PREFIX}text`,
};

export default Text;



// WEBPACK FOOTER //
// ./components/Text/Text.js